module.exports = __webpack_public_path__ + "img/GEOGRAFIA.5e641608.png";